import { readItems } from "@directus/sdk";
import directus from "./directusClient";
import {
  ACTIVITY_COLLECTION,
  ACTIVITY_FIELDS,
  ACTIVITY_SORT,
  BLOCK_COLLECTION,
  BLOCK_FIELDS,
  LESSON_COLLECTION,
  LESSON_FIELDS,
  LESSON_SORT,
  activitiesForBlockFilter,
  blocksForLessonFilter,
  eligibleLessonFilter,
  mapBlocks,
  mapLearnerActivities,
  mapLessons,
} from "./adapter";

// Read-only. Curriculum records are never written from this app.
const liveRepository = {
  isPreview: false,

  listLessons: async () =>
    mapLessons(
      await directus.request(
        readItems(LESSON_COLLECTION, {
          fields: LESSON_FIELDS,
          filter: eligibleLessonFilter(),
          sort: LESSON_SORT,
          // Every grade, week and subject: a fixed cap would silently drop
          // the later weeks as approved curriculum grows.
          limit: -1,
        })
      )
    ),

  listBlocks: async (lessonId) =>
    mapBlocks(
      await directus.request(
        readItems(BLOCK_COLLECTION, {
          fields: BLOCK_FIELDS,
          filter: blocksForLessonFilter(lessonId),
          sort: ["sort"],
          limit: 50,
        })
      )
    ),

  // All approved, active activities attached to this exact lesson block.
  listLearnerActivities: async ({ lessonId, blockId }) => {
    const rows = await directus.request(
      readItems(ACTIVITY_COLLECTION, {
        fields: ACTIVITY_FIELDS,
        filter: activitiesForBlockFilter({ lessonId, blockId }),
        sort: ACTIVITY_SORT,
        limit: 50,
      })
    );
    return mapLearnerActivities(rows);
  },
};

export default liveRepository;
